export default __webpack_public_path__ + "static/media/cover-color.0958df91.png";